var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8009 26.1959C35.442 23.7182 35.4209 21.0289 34.5745 18.4137C32.2555 11.2281 24.6722 7.32433 17.639 9.69201C10.6037 12.0618 6.78236 19.8081 9.10137 26.9936C9.94561 29.611 11.4944 31.7861 13.4538 33.3857H13.4516L29.9936 47.9705L34.8009 26.1959Z",
    fill: "#7CCC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1991 26.1959C24.558 23.7182 24.5791 21.0289 25.4255 18.4137C27.7445 11.2281 35.3278 7.32433 42.361 9.69201C49.3964 12.0618 53.2176 19.8081 50.8986 26.9936C50.0544 29.611 48.5056 31.7861 46.5463 33.3857H46.5484L30.0064 47.9705L25.1991 26.1959Z",
    fill: "#7CCC90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6929 39.4499L18.9678 25.1063L15.9928 29.5687H9.41667L7.25 25.2354H13.6738L19.3656 16.6978L26.8071 30.5208L29.8265 25.2354H39.75V29.5687H32.3402L26.6929 39.4499Z",
    fill: "#329F4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1014 26.9937C8.91309 26.4118 8.77979 25.8236 8.67188 25.2354H4V29.5687H10.2397C9.78483 28.7668 9.39762 27.9098 9.1014 26.9937Z",
    fill: "#7CCC90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.596837df6c197f1b008b841af8490224.svg";
export { ForwardRef as ReactComponent };